import * as Components from './../../../../Components';
import PasswordReset from '../../../Modal/PasswordReset';
import { TypeOfAuth } from './../menu-auth-type';

export default [
    {
        label: 'Login',
        path: '/',
        hidden: true,
        component: Components.login,
        authType: TypeOfAuth.NonAuth
    },
    {
        label: 'Reset Password',
        path: '/ResetPassword/:id',
        hidden: true,
        component: PasswordReset,
        authType: TypeOfAuth.NonAuth
    }
];
